export default __webpack_public_path__ + "static/new8-10-7cb8d5d77a3ccd816530688520419a08.jpg";